/**
 * Safe clipboard copy with fallback for environments where the
 * Clipboard API is blocked (e.g. iframes with restrictive Permissions-Policy).
 *
 * Returns a Promise<boolean>: true on success, false otherwise.
 * NEVER throws — safe to call from onClick without try/catch.
 */
export async function copyToClipboard(text) {
  const value = text == null ? '' : String(text);

  // Preferred modern API
  try {
    if (typeof navigator !== 'undefined'
        && navigator.clipboard
        && typeof navigator.clipboard.writeText === 'function') {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch (_err) {
    // fall through to legacy fallback
  }

  // Legacy fallback: hidden textarea + execCommand('copy')
  try {
    const ta = document.createElement('textarea');
    ta.value = value;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.opacity = '0';
    ta.style.pointerEvents = 'none';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return !!ok;
  } catch (_err) {
    return false;
  }
}
